// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__jA8LM","clickedWithMouse":"MenuLabel_clickedWithMouse__2lOKs","isOpen":"MenuLabel_isOpen__1T_uz"};